import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@project-management-system/backend-utils';
import { BuyerDestinationService } from 'packages/libs/shared-services/src/common';
import { StockItemstransferEntity } from './stock-transfer-items-entity';
import { StocktransferEntity } from './stock-transfer-entity';
import { StockTransferService } from './stock-transfer-service';
import { StockTransferController } from './stock-transfer-controller';
import { StocksRepository } from '../stocks/repository/stocks.repository';
import { StocksEntity } from '../stocks/stocks.entity';
import { PlantsRepository } from '../plants/plants.repo';
import { Plants } from '../plants/plants.entity';

@Module({
    imports: [
        TypeOrmModule.forFeature([StocktransferEntity,StockItemstransferEntity,StocksEntity,Plants]),
        ],
        controllers: [StockTransferController],
        providers: [StockTransferService,ApplicationExceptionHandler,StocksRepository,PlantsRepository]
      })
export class StokTransferModule{
    
}